import { render, staticRenderFns } from "./ModalAdd.vue?vue&type=template&id=3dc9cf30&"
import script from "./ModalAdd.vue?vue&type=script&lang=js&"
export * from "./ModalAdd.vue?vue&type=script&lang=js&"
import style0 from "./ModalAdd.vue?vue&type=style&index=0&id=3dc9cf30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports